import React, { useEffect } from "react";
import { useDispatch } from "react-redux";

import BottomControls from "components/UI/_TODO/WorkOrMaterialsModals/components/BottomControls/BottomControls";
import { workFields, worksFormCols } from "pages/HandBook/HandBook";
import { handBookActions } from "pages/HandBook/model/slice";
import { addCheckedExpendituresToTemplate } from "pages/HandBook/model/thunks";
import { HANDBOOK_EXPENDITURE_APPROVAL_STATUS } from "pages/HandBook/model/types";

import HandBookList, { IHandbookColumn } from "../../HandBookList/HandBookList";
import { useCreateHandbookContext } from "../CreateHandbookContext";
import { useTypedSelector } from "app/store/typedUseSelector";
import ButtonBase from "shared/ui/controls/ButtonBase";
import InputBase, { INPUT_BASE_VARIANTS } from "shared/ui/inputs/InputBase";
import SliderModal from "shared/ui/modal/SliderModal/SliderModal";

import { LOCALIZATION_CONFIG } from "constants/localization";

import { transformDigitToFinancial } from "utils/formatters/transformDigitToFinancial";

import styles from "./CreateHandbookTemplateExpenditure.module.scss";

export interface CreateHandbookTemplateExpenditureProps {
  sectionId: string;
}

const modalColPercents = [64, 12, 12, 12];

const CreateHandbookTemplateExpenditure: React.FC<CreateHandbookTemplateExpenditureProps> = ({ sectionId }) => {
  const dispatch = useDispatch();
  const { setIsSectionCreating: setOpen, isSectionCreating: isOpen } = useCreateHandbookContext();
  const isPending = useTypedSelector((state) => state.handBookReducer.loadings)["addCheckedExpendituresToTemplate"];

  const editings = useTypedSelector((state) => state.handBookReducer.editings);
  const checkedCount = Object.values(editings.checked).filter((v) => v).length;

  const closeModal = () => {
    setOpen(false);
    dispatch(handBookActions.clearEditings());
  };

  const addExpenditures = () => {
    dispatch(addCheckedExpendituresToTemplate({ sectionId, successCallback: closeModal }));
  };

  useEffect(() => {
    dispatch(handBookActions.clearEditings());
  }, [isOpen]);

  const changeCount = (id: number) => (e: React.ChangeEvent) => {
    const count = (e.target as HTMLInputElement)?.value || "";
    if (!editings.checked[id]) {
      dispatch(handBookActions.localCheckItem({ id, isChecked: true }));
    }
    if (editings.checked[id] && !count) {
      dispatch(handBookActions.localCheckItem({ id, isChecked: false }));
    }
    dispatch(handBookActions.localChangeItem({ id, change: { count: count } }));
  };

  const modalWorkCols: IHandbookColumn[] = [
    { header: { title: "Наименование", filterName: "name" }, render: (item) => item.name },
    {
      header: { title: "Кол-во" },
      render: (item) => (
        <InputBase
          value={editings.changes[item.id]?.count}
          onChange={changeCount(item.id)}
          variant={INPUT_BASE_VARIANTS.SECONDARY}
          classNameInput={styles.textInput}
        />
      ),
      isCentered: true,
    },
    { header: { title: "Ед. изм." }, render: (item) => item.measure, isCentered: true },
    {
      header: { title: `Цена ${LOCALIZATION_CONFIG.currency}` },
      render: (item) => transformDigitToFinancial(item.price),
      isRighted: true,
    },
  ];

  return (
    <SliderModal
      isOpen={!!isOpen}
      closeHandler={closeModal}
      className={styles.modal}
      childrenContainerClassName={styles.modalContainer}
      header={<h3 className={styles.heading}>Работы</h3>}
    >
      <div className={styles.list}>
        <HandBookList
          tableHeadClassName={styles.listHead}
          fields={workFields} // не используется в списке в модалке
          columns={modalWorkCols}
          defaultFilter={{ type: "work", status: HANDBOOK_EXPENDITURE_APPROVAL_STATUS.APPROVED }}
          key="work"
          colPercents={modalColPercents}
          formColPercents={worksFormCols} // не используется в списке в модалке
          canCheckRows
        />
      </div>
      <BottomControls isExists isDoubleBtns noWrapper>
        <ButtonBase secondary onClick={closeModal}>
          Отменить
        </ButtonBase>
        <ButtonBase primary disabled={!checkedCount} onClick={addExpenditures} isLoading={isPending}>
          {checkedCount ? `Добавить: ${checkedCount}` : `Добавить`}
        </ButtonBase>
      </BottomControls>
    </SliderModal>
  );
};

export default React.memo(CreateHandbookTemplateExpenditure);
